import { useMemo } from 'react'
import { Trans, useLingui } from '@lingui/react/macro'

export const usePromotionsTrads = (): Record<string, () => React.ReactNode> => {
	const { t } = useLingui()

	return useMemo(
		() => ({
			'priceCode.duration.negotiated_price': () => t`Tarif négocié`,
			'rebate_codes.code.credit_code': () => t`Avoir`,
			'rebate_codes.code.generic': () => t`Promotion`,
			'rebate_codes.code.test_code': () => t`Code de test`,
			'promotion.wallet_rebate': () => t`Réduction wallet`,
			'promotion.maintenance': () => t`Remise opération de maintenance`,
			'promotion.owner': () => t`Remise propriétaire`,
			'priceCode.duration.day_rate_weekday': () => (
				<Trans>
					Remise <strong>Forfait journée (hors week-end)</strong> appliquée
				</Trans>
			),
			'priceCode.duration.day_rate_weekend': () => (
				<Trans>
					Remise <strong>Forfait journée (week-end)</strong> appliquée
				</Trans>
			),
			'priceCode.duration.min_duration_billed_60': () => (
				<Trans>
					Minimum de facturation <strong>1h</strong>
				</Trans>
			),
			'priceCode.duration.min_duration_billed_90': () => (
				<Trans>
					Minimum de facturation <strong>1h30</strong>
				</Trans>
			),
			'priceCode.duration.min_duration_billed_120': () => (
				<Trans>
					Minimum de facturation <strong>2h</strong>
				</Trans>
			),
			'rebate_codes.code.godfather_code': () => (
				<Trans>
					Remise <strong>code Parrain</strong> appliquée
				</Trans>
			),
			'rebate_codes.code.godson_code': () => (
				<Trans>
					Remise <strong>code Filleul</strong> appliquée
				</Trans>
			),
			'rebate_codes.code.sorry_code': () => (
				<Trans>
					Remise <strong>code Cadeau</strong> appliquée
				</Trans>
			),
			'rebate_codes.code.welcome_code': () => (
				<Trans>
					Remise <strong>code WELCOME</strong> appliquée
				</Trans>
			),
			'promotion.back_to_school_day': () => (
				<Trans>
					<strong>20% de remise</strong> en réservant pour la rentrée !
				</Trans>
			),
			'promotion.cocoon_space': () => (
				<Trans>
					Remise <strong>Employé Cocoon Space</strong> appliquée
				</Trans>
			),
			'promotion.discount_20p': () => (
				<Trans>
					Remise négociée : <strong>20%</strong>
				</Trans>
			),
			'promotion.discount_35p_day': () => (
				<Trans>
					Remise négociée : <strong>35%</strong> sur les forfaits jours
				</Trans>
			),
			'promotion.early_booking': () => (
				<Trans>
					<strong>10% de remise ! </strong> Vous gagnez à être prévoyant
				</Trans>
			),
			'promotion.early_booking_day_large': () => (
				<Trans>
					<strong>20% de remise sur le forfait journée !</strong> Vous gagnez à
					être prévoyant'
				</Trans>
			),
			'promotion.early_booking_lyon': () => (
				<Trans>
					<strong>30% de remise !</strong> Vous gagnez à être prévoyant
				</Trans>
			),
			'promotion.last_minute_large': () => (
				<Trans>
					<strong>50% de remise</strong> en réservant à la dernière minute
				</Trans>
			),
			'promotion.low_season': () => (
				<Trans>
					<strong>20% de remise</strong> en réservant pendant les vacances !
				</Trans>
			),
			'promotion.low_season_xmas': () => (
				<Trans>
					<strong>30% de remise</strong> en réservant pendant les vacances de
					Noël !
				</Trans>
			),
			'promotion.month_user': () => (
				<Trans>
					Remise <strong>Location au mois</strong> appliquée
				</Trans>
			),
			'promotion.new_city': () => (
				<Trans>
					<strong>20% de remise</strong> en réservant à notre nouvelle adresse !
				</Trans>
			),
			'promotion.new_space': () => (
				<Trans>
					Remise <strong>Découverte nouveau Cocoon</strong> appliquée
				</Trans>
			),
			'promotion.scomblez': () => (
				<Trans>
					Remise négociée : <strong>20%</strong>
				</Trans>
			),
			'promotion.summer_day': () => (
				<Trans>
					<strong>50% de remise</strong> en réservant sur la période estivale !
				</Trans>
			),
			'promotion.summer_day_weekend': () => (
				<Trans>
					<strong>35% de remise</strong> en réservant sur la période estivale !
				</Trans>
			),
		}),
		[t],
	)
}
